import { render, staticRenderFns } from "./ProductoCard.vue?vue&type=template&id=6ee26820"
import script from "./ProductoCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductoCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports